import type { TextAlign } from "@/lib/cms-puck/block-style";

/** Ratio d'affichage d'une image du bloc Média (parité BO ↔ front, JIT-safe). */
export type MediaAspect = "auto" | "1/1" | "4/3" | "3/2" | "16/9";

/**
 * Classe d'alignement de texte (JIT-safe, classes en toutes lettres). Partagée
 * par les blocs de contenu (Heading/Button/Quote/Icon). Parité BO ↔ front.
 */
export const TEXT_ALIGN_CLASS: Record<"left" | "center" | "right", string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};

/** Alignement du texte courant (RichText), justification comprise. Parité front. */
export const PROSE_ALIGN_CLASS: Record<TextAlign, string> = {
  ...TEXT_ALIGN_CLASS,
  justify: "text-justify",
};
